import React from "react";
import Navigation from "./layout/Navigation/Navigation";
import Footer from "./layout/Footer/Footer";
import NavigationMobile from "./layout/Navigation/NavigationMobile";

const Layout = ({children, navigationCallback}) => (
  <>
    <Navigation contattiCallBack={navigationCallback} />
    <NavigationMobile contattiCallBack={navigationCallback} />
    {children}
    <Footer />
  </>
);

export default Layout;
